import React from 'react';
import { ArrowRight, BoxIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card } from './ui/Card';
interface ProtocolCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  checklist: string[];
  link: string;
}
export function ProtocolCard({
  title,
  description,
  icon: Icon,
  checklist,
  link
}: ProtocolCardProps) {
  return <Card hoverEffect className="flex flex-col h-full" data-id="element-480">
      <div className="p-4 sm:p-6 flex-grow" data-id="element-481">
        <div className="h-10 w-10 sm:h-12 sm:w-12 rounded-lg bg-cyan-500/10 flex items-center justify-center mb-3 sm:mb-4" data-id="element-482">
          <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-cyan-500" data-id="element-483" />
        </div>
        <h3 className="text-lg sm:text-xl font-bold text-slate-100 mb-2" data-id="element-484">
          {title}
        </h3>
        <p className="text-slate-400 text-xs sm:text-sm mb-4 sm:mb-6" data-id="element-485">
          {description}
        </p>
        <div className="bg-slate-950/50 rounded-md p-3 sm:p-4 border border-slate-800/50" data-id="element-486">
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2 sm:mb-3" data-id="element-487">
            Do this now
          </p>
          <ul className="space-y-1.5 sm:space-y-2" data-id="element-488">
            {checklist.map((item, idx) => <li key={idx} className="flex items-start text-xs sm:text-sm text-slate-300" data-id="element-489">
                <div className="h-1.5 w-1.5 rounded-full bg-cyan-500 mr-2 mt-1.5 flex-shrink-0" data-id="element-490" />
                <span className="break-words" data-id="element-491">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
      <Link to={link} className="border-t border-slate-800 p-3 sm:p-4 flex items-center justify-between text-xs sm:text-sm font-medium text-cyan-500 hover:bg-slate-800/50 transition-colors touch-manipulation" data-id="element-492">
        <span data-id="element-493">View Protocol</span>
        <ArrowRight className="h-3 w-3 sm:h-4 sm:w-4" data-id="element-494" />
      </Link>
    </Card>;
}